import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center py-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card5 = _resolveComponent("Card5")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listEvents, (evento, index) => {
        return (_openBlock(), _createBlock(_component_Card5, {
          key: index,
          to: `tournaments/${evento.slug}/sports`,
          evento: evento
        }, null, 8, ["to", "evento"]))
      }), 128))
    ])
  ]))
}